var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRacer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394.642,
    height: 797.677,
    viewBox: "0 0 394.642 797.677",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1165.08 1160.17h299.53V591.839h-299.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 669.352 421.612) scale(117.12412)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 628.9 442.55) scale(29.67742)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 669.352 494.715) scale(105.92672)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 669.352 332.57) scale(47.72195)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(178.944 667.258 444.184) scale(114.34339)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed785f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce341a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(92.50588) rotate(-88.324 10.852 -2.866)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(291.22131) rotate(-88.324 3.753 -.706)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc2913",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#bf2a13",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#db5335",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db5335",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.116 1208.358 -75.246) scale(470.96426)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b81f0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#c32b0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e86a49",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-87.51 1111.403 -141.643) scale(26.73491)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(174.218 624.51 578.305) scale(40.98273)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.141 1196.695 -42.457) scale(248.6897)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dd5231",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd5231",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-115.184 1006.527 184.454) scale(90.96948)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01d0e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#cd290d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd290d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-75.2258 0 0 -75.2258 1338.704 1170.547)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10c0a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#a60f0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60f0b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(334.87621 -334.87621) rotate(-88.324 -1.851 -1.681)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230.69 787.02h66.74V651.519h-66.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(117.12412 0 0 -117.12412 1338.502 843.211)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(29.67742 0 0 -29.67742 1419.405 885.086)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(105.92672 0 0 -105.92672 1338.502 989.417)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(47.72195 0 0 -47.72195 1338.502 665.127)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(112 2.06452 2.06452 -112 1336.893 876.024)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed785f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce341a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-92.50588 92.50588) rotate(-88.324 -3.619 12.034)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-291.22131 291.22131) rotate(-88.324 -.844 4.027)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc2913",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#bf2a13",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#db5335",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db5335",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-470.96426 470.96426) rotate(-88.116 -.277 2.778)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b81f0d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#c32b0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e86a49",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e86a49",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-26.73491 26.73491) rotate(-87.51 -8.499 46.995)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(40.7742 4.12903 4.12903 -40.7742 1373.1 1090.735)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ab160b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab160b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(248.6897 -248.6897) rotate(87.859 5.205 .592)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42f15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dc5232",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dd5231",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd5231",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(90.96948 -90.96948) rotate(64.816 17.909 5.75)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01d0e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#cd290d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd290d",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(75.2258 0 0 -75.2258 1338.502 1170.534)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a10c0a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#a60f0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60f0b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-334.87621) rotate(-88.324 -1.851 -1.681)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd5334",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4978a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379.78 787.007h66.73V651.506h-66.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222.7 1101.18h231.03V860.896H1222.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1453.734 1058.095s-36.167 16.839-39.119 18.348c0 0 2.145-20.897 12.241-31.629 0 0-3.322-3.988-7.452 2.188-4.129 6.177-10.258 8.241-10.258 8.241s14.149-15.972 13.27-17.927c-.878-1.954-29.203 17.774-34.123 27.266-4.92 9.492-9.34 19.468-9.34 19.468s-2.903-1.452-15.807-5.581c-12.903-4.129-47.483-3.613-56.257-4.129-8.775-.516-9.217 9.71-9.217 9.71s-5.368-14.765-8.212-18.553c-2.844-3.789-39.11-31.513-39.11-31.513s7.449 13.031 13.129 13.809c5.679.778 16.845 20.87 17.224 28.096.379 7.225 5.038 25.29 5.038 25.29s-5.691-25.29-8.788-29.42c-3.097-4.129-6.451-14.709-11.354-18.838-4.904-4.129-16.348-14.968-17.594-16-1.245-1.032-4.408-2.937-4.408-2.937l16.817 27.982 3.065 21.664s-4.507-7.825-13.129-10.687c-8.622-2.861-19.443-10.216-22.743-12.538-3.299-2.323-4.905-4.259-4.905-4.259s.245-53.342.472-64.024l4.433 2.218 2.785 27.613.912-21.154s.23 7.477 6.424 14.702c6.193 7.226 14.389 20.187 26.528 23.905 11.762 3.603 44.762 17.328 72.116 15.78 27.356-1.549 45.965-1.878 71.358-13.865 25.393-11.988 34.424-29.417 36.727-40.522 2.303-11.104 2.222-78.473.972-96.272-1.25-17.8-3.166-43.631-3.166-43.631s8.109 34.956 7.336 46.006c-.775 11.051 3.418 143.72 4.135 151.193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1048",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(231.73742 -231.73742) rotate(-1.056 -226.435 -288.54)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1048)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(231.73742 -231.73742) rotate(-1.056 -226.435 -288.54)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1279.82 930.898h128.74v-114.69h-128.74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1290.982 924.227c17.971.436 34.01 9.047 49.991 6.032 15.98-3.016 60.084-4.819 63.322-8.304 3.239-3.486 8.899-58.518-2.705-78.744-11.605-20.226-23.476-14.729-32.766-22.381-9.29-7.651-64.516-4.906-66.064 1.721-1.549 6.628 8.258 31.869 5.678 38.345-2.582 6.477-19.586-26.556-22.697-27.072-3.11-.516 1.019 43.839-3.11 56.242-4.129 12.403-2.488 32.783-2.488 32.783z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1114",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(128.24087 -128.24087) rotate(-1.056 -364.136 -545.161)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient1114)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(128.24087 -128.24087) rotate(-1.056 -364.136 -545.161)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.484 1172.07H1099.5V570.226H819.484z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-214.14964 214.14964) rotate(-88.508 -.165 4.937)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(15.35556 0 0 -15.35556 1103.86 674.692)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(161.52376 -161.52376) rotate(87.94 6.628 .002)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(341.73401 -341.73401) rotate(8.588 22.312 15.05)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(127.88548 -127.88548) rotate(8.588 50.475 48.755)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0071bc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-245.33535 245.33535) rotate(-88.649 -.073 4.14)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(68.12904 0 0 -68.12904 984.436 763.79)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0b3128",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(57.67234 -57.67234) rotate(-78.751 1.766 -16.513)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(9.8274 49.41 49.41 -9.8274 1020.535 687.921)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(41.0715 -41.0715) rotate(-78.751 1.899 -23.816)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(30.06596 -30.06596) rotate(-78.751 2.284 -33.015)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(35.71847 -35.71847) rotate(-78.751 1.688 -28.057)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(103.79456 -103.79456) rotate(-57.179 -.735 -11.988)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(78.2751 -78.2751) rotate(-88.986 1.974 -11.145)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.508 771.079h13.622v-54.81h-13.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(87.49757 -87.49757) rotate(-88.986 1.797 -9.92)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(23.37066 0 0 -23.37066 1086.371 819.318)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#1c100f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c100f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(74.4895 -74.4895) rotate(30.385 24.005 20.073)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#006da7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006da7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -81.3434 -81.3434 0 988.952 694.387)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0076c5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076c5",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -54.96774 -54.96774 0 989.79 706.144)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0a4c65",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a4c65",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-255.98512 255.98512) rotate(-88.508 -.383 3.86)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e5068",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-216.07106 216.07106) rotate(-88.508 -.51 4.359)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0070af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#186ec2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186ec2",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-195.33115 195.33115) rotate(-88.508 .202 5.822)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(577.77899) rotate(-90 1.997 .138)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(183.49857 -183.49857) rotate(-89.275 0 -5.645)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#035269",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035269",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050.94 1137.19h39.76v-136.12h-39.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.508 945.968 50.06) scale(214.14964)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-15.35556 0 0 -15.35556 858.789 674.682)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(161.52376 -161.52376) rotate(87.94 6.278 -.335)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-341.73401) rotate(8.588 19.44 -23.194)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-171.412 513.164 410.983) scale(127.88548)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#2e3192",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0071bc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(245.33535) rotate(-88.649 3.927 .044)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-68.12904 0 0 -68.12904 978.213 763.78)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#114446",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0b3128",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-57.67234) rotate(-78.751 -15.25 4.22)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(101.249 188.775 730.548) scale(50.37783)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-41.0715) rotate(-78.751 -21.994 5.297)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-30.06596) rotate(-78.751 -30.355 6.755)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-35.71847) rotate(-78.751 -25.786 5.42)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(122.821 303.207 576.4) scale(103.79456)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-78.2751) rotate(-88.986 -10.563 1.616)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952.522 771.069h13.618v-54.81h-13.618z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(91.014 128.586 809.601) scale(87.49757)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-23.37066 0 0 -23.37066 876.277 819.308)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#212224",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#1c100f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c100f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-149.615 575.279 219.082) scale(74.48951)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0072b2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#006da7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006da7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 834.037 -139.66) scale(81.34339)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#005d85",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0076c5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076c5",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -54.96774 54.96774 0 972.858 706.134)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0e4d67",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#0a4c65",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a4c65",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(255.98512) rotate(-88.508 3.45 -.075)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#597a84",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1e5068",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2c5a99",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5a99",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.508 871.024 -65.468) scale(216.07106)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#006392",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#0070af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#186ec2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186ec2",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-88.508 1020.828 129.962) scale(195.33115)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(268.85062) rotate(-90 3.847 .541)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90.725 -41.483 968.901) scale(183.49857)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#0070b5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#035269",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035269",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.945 1137.18h39.769v-136.12h-39.769z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(168.851 400.629 577.409) scale(36.0349)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#1a5678",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(178.9903 0 0 -178.9903 891.83 955.236)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#1a1a1a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#424242",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.008 689.708h56.105v-86.735h-56.105z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1066.13 768.86h36.19v-97.837h-36.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.628 1141.46h257.342v-114.32H849.628z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(12.23642 0 0 -12.23642 1053.891 839.46)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "gray",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#4d4d4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#081101",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081101",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1055.21 1033.25h4.96V926.789h-4.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-106.46805 106.46805) rotate(-88.508 .012 9.952)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ffe696",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#636144",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636144",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.06 1032.8h17.615V762.402H897.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-270.54063 270.54063) rotate(-88.508 .28 3.632)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#978944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#ffe696",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#636144",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636144",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 173.659 699.798) scale(180.709)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 281.505 807.666) scale(180.705)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 279.806 701.505) scale(68.8945)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 233.002 874.728) scale(94.3246)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 105.067 748.656) scale(94.0274)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0d6591",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#29abe2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(56.30471 0 0 -56.30471 1044.949 1151.7)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(55.6341 0 0 -55.6341 861.393 1152.586)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#0171b0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#16506b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#00648f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00648f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(51.61638 0 0 -51.61638 863.718 1153.886)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(179.989 549.83 576.115) scale(51.61638)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.412 1184.05h316.547v-586.3H41.412z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.511 581.232 392.47) scale(195.68098)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -39.22107 39.22107 0 202.603 656.111)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -27.176 27.176 0 207.33 667.874)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 441.383 251.48) scale(37.57926)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90 451.99 234.209) scale(15.87097)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c695f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 554.33 401.51) scale(341.85351)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 388.205 292.507) scale(50.35491)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-195.7686) rotate(87.247 1.83 -2.513)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-511.46419) rotate(87.247 1.02 -1.3)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 620.68 465.666) scale(138.65765)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 574.004 462.418) scale(294.77964)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#458800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#407500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407500",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 565.187 454.74) scale(223.64261)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#363029",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#191c0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c0f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-234.561) rotate(87.247 2.06 -2.537)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-92.753 615.743 510.564) scale(365.32494)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#326100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#58a200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58a200",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 58.135 492.33) scale(12.9067)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-11.22762 0 0 -11.22762 116.268 981.276)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-27.24143 0 0 -27.24143 105.04 987.493)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-96.028 594.282 523.8) scale(167.11744)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#417600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-109.804 492.895 533.423) scale(88.27635)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-109.804 495.927 537.557) scale(119.58861)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-44.68367 0 0 -44.68367 167.363 1149.128)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(34.73803) rotate(88.848 -14.76 19.192)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5d00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274700",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(88.848 -498.342 692.234) scale(27.12284)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a6800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#284a00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(102.73043) rotate(88.848 -4.504 6.184)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437800",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(195.68098 -195.68098) rotate(88.489 3.265 -1.812)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#6de100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#80fe00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -38.23526 -38.23526 0 268.155 655.955)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -27.176 -27.176 0 263.202 667.874)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -37.57926 -37.57926 0 281.855 692.862)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282622",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -15.87097 -15.87097 0 253.492 686.2)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#45454b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c695f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(341.8535 -341.8535) rotate(87.247 1.923 -.977)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1f4f02",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#1f4f01",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#356600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(50.35491 -50.35491) rotate(87.247 10.78 -3.174)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(195.7686 -195.7686) rotate(87.247 3.035 -1.25)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#74de00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#6cd200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(511.46419 -511.46419) rotate(87.247 1.48 -.815)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#467b00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#67ba00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#7de200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76f600",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(138.65765 -138.65765) rotate(87.247 5.224 -2.913)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(294.77964 -294.77964) rotate(87.247 2.446 -1.204)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#336200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#3c7200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#458800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#407500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407500",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(114.75313 -114.75313) rotate(87.247 5.992 -3.667)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#363029",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#191c0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c0f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(223.64261 -223.64261) rotate(87.247 3.188 -1.545)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#040204",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#242121",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#363029",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#191c0f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c0f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(234.561 -234.561) rotate(87.247 3.065 -1.482)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#444141",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#725f7d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3c3f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(365.32494 -365.32494) rotate(87.247 2.112 -1.091)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#6cc500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#83ee00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#326100",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#58a200",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58a200",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(12.9067 0 0 -12.9067 355.488 984.658)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#3d8300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(11.22762 0 0 -11.22762 355.49 981.276)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(27.24143 0 0 -27.24143 366.717 987.493)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#7fe600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(167.11744 -167.11744) rotate(83.972 4.894 -2.383)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#2d451d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#417600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285300",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(88.27635 -88.27635) rotate(70.196 11.27 -4.143)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#488500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(119.58861 -119.58861) rotate(70.196 8.369 -3.094)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#469700",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa000",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(44.68367 0 0 -44.68367 304.395 1149.128)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675d6f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-34.73803 34.73803) rotate(88.848 -21.55 12.263)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5d00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274700",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-27.12284 27.12284) rotate(88.848 -27.07 16.649)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a6800",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#284a00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-102.73043 102.73043) rotate(88.848 -6.8 3.84)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68be00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437800",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.33 1136.69h213.237v-57.08H138.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.814 1127.877c.398-.968-14.613-3.459-17.193-3.31-2.581.149-7.658 3.31-7.658 3.31s-33.489 6-50.077 4.774-40.846-2.056-52.201.165c-11.354 2.223-26.838 6.17-35.613 2.132-8.774-4.039-47.741-50.536-47.741-50.536l.372-4.799s31.73 21.216 70.66 19.549c38.929-1.668 105.674-8.361 112.451-12.123 6.778-3.763 19.011-4.13 19.011-4.13s3.521-2.064 5.872 4.13c2.351 6.193 5.157 16.677 4.846 21.113-.31 4.435-.696 14.068-.696 14.068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4542",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(204.85174 -204.85174) rotate(9.462 33.385 1.606)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4542)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(204.85174 -204.85174) rotate(9.462 33.385 1.606)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.28 961.918h162.55V804.976H157.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.547 961.588s-27.152.743-35.281 0c-8.129-.743-6.968-7.753-17.226-10.442-10.258-2.688-64.897-4.065-70.742 0-5.844 4.067-13.451 11.208-17.516 8.905-4.065-2.303-21.103-19.335-21.487-38.69-.384-19.355 6.599-43.162 7.107-65.452.509-22.29-.251-45.814 0-47.472.251-1.657 10.592 21.311 12.39 31.118 1.796 9.806 4.119 5.935 4.893-8 .774-13.936-11.419-34.792 6.678-23.202 18.096 11.588 53.129 24.75 63.096 24.75 9.968 0 29.904-1.807 29.613 6.452-.29 8.257 6.042 26.153 9.581 16.354 3.539-9.798 9.301-22.806 13.65-11.968 4.35 10.839 17.622 102.906 15.244 117.647"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4604",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(162.55013 0 0 -162.55013 157.28 883.447)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4604)",
    stroke: "none",
    d: "M-32768 32767h65535v-65535h-65535z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(162.55013 0 0 -162.55013 157.28 883.447)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.983 755.773h40.352V633.239h-40.352z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4666",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4674",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.219 1175.49h296.777V577.234H425.219z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4690",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4726",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(123.48387 0 0 -123.48387 602.244 864.194)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#524430",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#392a15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392a15",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4736",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4762",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(84.46748 0 0 -84.46748 605.873 753.829)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4786",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(111.14707 0 0 -111.14707 603.437 979.959)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4796",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4828",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(255.48856 -255.48856) rotate(89.653 3.167 -.587)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffdd39",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4852",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(30.46916 0 0 -30.46916 691.405 861.778)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4862",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4898",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(62.98678 -62.98678) rotate(88.591 10.712 .18)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#ffde3d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc008",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4922",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(74.12726 -74.12726) rotate(13.309 52.641 33.209)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4950",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(70.98997 1.7106 1.7106 -70.98997 683.451 916.332)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4960",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4988",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(41.26448 0 0 -41.26448 684.07 1149.044)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4998",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5040",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(38.19355 0 0 -38.19355 686.502 1140.936)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b4b4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#967e81",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#7d5f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5060",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(34.29031 -34.29031) rotate(88.152 27.623 -6.157)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9d1d3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad959a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5080",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(44.54008 -44.54008) rotate(88.152 21.379 -4.861)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#562652",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6c97",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5108",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(1.54839 -48 -48 -1.54839 669.74 1209.804)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5136",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(1.03226 -144 -144 -1.03226 657.246 1185.821)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#f4b80b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5156",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-40.14541 40.14541) rotate(81.87 -23.971 3.954)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bca6af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74545e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5166",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5192",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(103.49191 -103.49191) rotate(89.286 8.608 -2.516)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc708",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5202",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5224",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(58.83871 0 0 -58.83871 607.018 1181.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2027",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2630",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5252",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(4.78226 0 0 -4.78226 731.663 863.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5262",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5288",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(18.82398 0 0 -18.82398 716.18 1071.917)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5312",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(18.82398 0 0 -18.82398 716.18 1064.497)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5336",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(18.82398 0 0 -18.82398 716.18 1056.872)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5360",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(28.82387 0 0 -28.82387 725.775 953.722)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5388",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(34.37492 0 0 -34.37492 721.018 959.432)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5398",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5434",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 303.496 432.097) scale(120.3871)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#25110c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#46322a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#524430",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#392a15",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392a15",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5444",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5470",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-85.28419 0 0 -85.28419 608.953 753.829)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5494",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 304.477 489.98) scale(109.77023)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5504",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5536",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90.347 756.186 200.948) scale(255.48856)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ffdd39",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5560",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 261.302 430.889) scale(30.46916)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5570",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5606",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.409 595.937 66.078) scale(62.98678)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb3c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#ffde3d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc008",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5630",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-166.691 319.802 384.441) scale(74.12726)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5658",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-71.01057) rotate(-1.38 -539.336 303.662)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5668",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5696",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-41.26448 0 0 -41.26448 529.94 1149.044)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#d39908",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5706",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5748",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 263.754 570.468) scale(38.19355)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b4b4d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#967e81",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#7d5f61",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5f61",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5768",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.848 811.42 329.413) scale(34.29031)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9d1d3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad959a",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5788",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-91.848 816.646 334.243) scale(44.54008)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#562652",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6c97",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5816",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-1.54839 -48 48 -1.54839 544.27 1209.804)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#b67c08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5844",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(-90.411 867.057 316.517) scale(144.0037)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#ac7308",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#f4b80b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#ffd63f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd108",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5864",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(40.14541) rotate(81.87 -8.851 21.388)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bca6af",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74545e",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5874",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5900",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-103.49191) rotate(89.286 2.743 -8.455)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac008",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc708",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5910",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5932",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 303.496 590.565) scale(58.83871)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2027",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2630",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5960",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-4.78226 0 0 -4.78226 482.346 863.13)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5970",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5996",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-18.82398 0 0 -18.82398 497.83 1071.917)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6020",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-18.82398 0 0 -18.82398 497.83 1064.497)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6044",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-18.82398 0 0 -18.82398 497.83 1056.872)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6068",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-28.82387 0 0 -28.82387 488.235 953.722)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#66514c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#9f6e64",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61474b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6096",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(-34.37492 0 0 -34.37492 492.992 959.432)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#9a6608",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6120",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(3.3638 0 0 -3.3638 632.62 868.21)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6144",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(2.638 0 0 -2.638 580.638 868.614)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824a08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f8bd0b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#a56e08",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56e08",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6154",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h1500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6162",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.631 749.857h17.608v-59.524h-17.608z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6178",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.24 1119.83h13.724v-94.96H500.24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6194",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.628 1117.54H716.68v-111.37H508.628z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6214",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.409 941.968h139.467V803.267H551.409z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6234",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.249 753.896h46.792v-95.58h-46.792z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 -612.548 1602.625)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4666)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4674)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(700.588 843.169)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.06-2.063.258-11.355 0-12.645-.12-.6-.52-1.223-.912-1.723-.063 5.167-.117 10.734-.147 16.295A43.18 43.18 0 000 0m-13.537-205.112l.014.019 3.311.797a244.37 244.37 0 00-3.325-.816m-4.047-3.048c-8.276-1.86-16.791-3.38-25.248-4.621a449.446 449.446 0 0124.775 4.757zm-218.32.136a449.414 449.414 0 0124.774-4.757c-8.456 1.241-16.972 2.761-25.247 4.621zm-4.534 2.931l.013-.019a244.37 244.37 0 00-3.325.816zm-13.524 192.448c-.258 1.29-1.06 10.582 0 12.645.35.68.718 1.339 1.059 1.927-.03-5.561-.084-11.128-.147-16.295-.392.5-.792 1.123-.912 1.723m86.024 324.516a36.06 36.06 0 004.557 1.161c3.738.68 7.841 1.217 12.031 1.635zm40.97-133.715v-.625h-.026v.626l.026-.001m36.387 134.876a36.032 36.032 0 004.558-1.161l-16.588 2.796c4.189-.418 8.292-.955 12.03-1.635m57.031-522.233a419.439 419.439 0 00-8.099-1.333c.743.122 4.946.81 8.099 1.333m-178.764-1.333c-2.845.44-5.546.887-8.097 1.333 3.15-.523 7.351-1.21 8.097-1.333m85.346-55.402c66.371 0 121.97 14.049 127.097 15.382l1.678-2.994v57.031l-1.291.904-2.064-6.258 1.019-29.581C-1.053-218.615-1.548-204-1.548-204c-5.176-1.548-10.548-2.926-16.024-4.157.016.011.231.145.562.365A394.916 394.916 0 01-1.548-204v2.129s-2.923-.972-8.622-2.415c.011.024 20.751 41.579 20.493 50.35-.259 8.775 5.677 84.129-6.968 98.323 0 0-2.161 14-3.871 16.516 0 0-.157 7.502-.306 17.93.683.556 1.328 1.359 1.854 2.586.775 1.807 1.42 12.065 1.42 12.065s.129 7.161-.645 8.839C1.343 3.326-.04 5.432-1.08 6.967c-.013 5.186-.002 10.249.048 14.84.12 11.217.354 38.107.568 63.568 7.52-2.846 18.412-6.861 19.045-6.988.967-.194 2.032 1.065 2.032 1.065.387.58 1.258 3.387.484 6.387-.774 3-10.742 10.838-15.484 13.161-1.873.917-3.955 1.226-5.952 1.222.189 22.797.339 41.326.339 41.326s5.419 8.259 5.419 29.936 4.388 59.226-3.483 80.903c0 0-7.162 29.355-14.904 38.581-7.741 9.225-34.258 32.064-76.645 38.645 0 0-25.355 2.71-37.355 2.71h-.026c-12 0-37.355-2.71-37.355-2.71-42.387-6.581-68.903-29.42-76.645-38.645-7.742-9.226-14.903-38.581-14.903-38.581-7.871-21.677-3.484-59.226-3.484-80.903 0-21.677 5.419-29.936 5.419-29.936s.15-18.529.34-41.326c-1.998.004-4.08-.305-5.953-1.222-4.742-2.323-14.71-10.161-15.484-13.161-.774-3 .097-5.807.484-6.387 0 0 1.065-1.259 2.033-1.065.632.127 11.524 4.142 19.044 6.988.214-25.461.448-52.351.568-63.568.05-4.591.061-9.654.048-14.84-1.04-1.534-2.423-3.641-2.886-4.644-.774-1.678-.646-8.839-.646-8.839s.646-10.258 1.42-12.065c.526-1.227 1.171-2.03 1.854-2.586-.149-10.428-.306-17.93-.306-17.93-1.709-2.516-3.871-16.516-3.871-16.516-12.645-14.194-6.709-89.548-6.968-98.323-.257-8.771 20.482-50.326 20.494-50.35-5.7 1.443-8.623 2.415-8.623 2.415V-204a394.916 394.916 0 0115.462-3.792c.331-.22.546-.354.562-.365-5.476 1.231-10.848 2.609-16.024 4.157 0 0-.495-14.615-1.019-27.452l1.019 29.581-2.064 6.258-1.29-.904v-57.031l1.677 2.994c5.128-1.333 60.726-15.382 127.097-15.382z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4690)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(737.34 814.033)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#55353c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-2.161 14-3.871 16.516c-1.71 2.516-3.065 2.903-3.065 2.903l-5.516-12.967 3.581-22.355s6-5.718 8.033-6.097c2.032-.38 4.354 4.742 4.548 5.032.193.29-1.162 10.742-1.162 10.742z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(729.338 822.99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#957b7e",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s3.486-23.408 6.1-25.924c2.612-2.516 3.677 1.741 3.677 1.741s-.775-10.257-.968-10.645c-.193-.387-9.58-3.677-9.58-2.226 0 1.452-1.162 19.839-1.162 19.839L-1.159-.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4726)",
    stroke: "none",
    d: "M605.34 1031.839l-3.096-341.284 76.133 1.162 36.125 62.111 3.165 51.966 4.812 46.432s3.249 48.001 3.249 50.71c0 2.71-1.548 51.097-1.548 53.419 0 2.323-1.701 49.42-1.701 49.42s-18.747 21.164-19.259 23.028c-.511 1.864-89.641 9.03-89.641 9.03z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4736)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(605.373 1035.452)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483a2c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v11.73l77.052-.246 19.675-28.258 13.402-17.613-2.32-5.032-9.082 3.871S83.89-23.935 82.396-22.967C80.903-22 23.032-2.064 22.452-2.064 21.871-2.064 0 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4762)",
    stroke: "none",
    d: "M635.921 811.71c-2.839-.774-28.903-14.709-28.903-14.709l-.45-9.549s54.901 1.033 59.546-2.064c4.646-3.097 9.808-6.775 8.774-18.355-1.032-11.581-3.87-48.742-3.87-48.742s6.081-12.387-65.145-12.387l1.145-10.065h36.518l30.063 2.839s5.463 17.739 4.645 21.677c-.819 3.94 11.35 52.314 10.062 54.415-1.288 2.102 4.054 31.783 1.163 32.94-2.615 1.047-42.001 4.108-51.589 4.108-1.01 0-1.688-.034-1.959-.108"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4786)",
    stroke: "none",
    d: "M606.776 1035.452l-1.112-5.419c59.87 0 86.79-21.678 94.14-25.807 7.35-4.128 5.814-14.709 5.814-14.709s-8.519-38.452-10.391-43.613c-1.871-5.161-9.999-3.355-9.999-3.355s-14.452 1.548-30.089 4.904c-15.637 3.354-36.75 3.354-36.75 3.354h-11.613l-3.339-9.806 33.017-8s56.974-9.452 58.773-8.517c1.8.936 17.025 48.498 15.475 50.137-1.551 1.639 3.883 22.31 3.883 22.31-33.03 36.302-90.821 38.567-104.733 38.567-1.984 0-3.076-.046-3.076-.046"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4796)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(604.826 701.904)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a99597",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s64.421-.687 71.242 6.495c6.821 7.182 2.821-7.243 2.821-7.243s-5.201-30.026-5.347-30.406c-.146-.381-66.524 1.863-66.524 1.863z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672.438 675.194)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7b6163",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-65.419v-20l53.225 2.517s8.516 2.129 9.484 3.773c.968 1.646 5.064 12.549 5.064 12.549z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4828)",
    stroke: "none",
    d: "M693.486 935.323c-1.807-.257-44.13 8.516-86.71 8.516l-.903-146.838h68.258s8.258.516 8.258-3.355-8-111.226-10.193-118.452c-2.194-7.226-3.743-17.549-65.42-17.549v-9.805l39.226-2.775 32.258 8.71 6.451 28.129s4.516 124.645 4.516 125.806c0 1.161 14.275 142.839 14.275 142.839v12.761s-8.21-27.729-10.016-27.987"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4852)",
    stroke: "none",
    d: "M696.74 938.077s-5.335-73.463-5.335-76.722c0-3.259 1.935-92.354 1.935-94.322 0-1.967 3.693-29.775 3.693-29.775l18.759 3.097 6.082 34.452s-6.093 79.933-6.379 58.065c-.284-21.869-8.8-54.968-10.598-64.645-1.797-9.677-3.234.58-4.396 5.806-1.16 5.226-1.548 52.838-1.548 52.838 12.774 3.097 16.542 8.324 16.542 8.324v13.347c-3.779-5.233-17.896-9.089-17.896-9.089-3.484 64.258 10.257 116.709 10.257 116.709l6.581 2.323 7.437 16.065-6.392 11.747z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4862)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(712.792 661.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#955808",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s15.484 20.903 15.774 21.484c.29.58 2.807 10.645 3 11.323.194.677-6.483.581-8.128 0C9 32.227-6.818 2.75-7.354 1.259c-.538-1.492-1.08-3-.541-2.807C-7.354-1.354 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(712.182 662.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2b50b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s15.61 19.987 16.771 25.117c1.162 5.129 2.613 3.774 2.613 3.677 0-.097-1.966-11.175-1.966-11.175S9.548 4.257 8.901 2.783c-.646-1.472-4.676-3.989-4.676-3.989z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(732.438 667.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#370f35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.064 6.258 1.29-.904v-57.032l-1.677 2.995z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4898)",
    stroke: "none",
    d: "M607.018 651.452v-47.741c69.678 0 127.484 15.484 127.484 15.484-.516.774-2.065 46.45-2.065 46.45-52.645-15.741-125.419-14.193-125.419-14.193"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4922)",
    stroke: "none",
    d: "M693.34 921.517c-4.258-27.871-8.903-191.226-13.16-213.291-4.258-22.064-7.742-53.031-7.742-53.031l19.772 3.896 6.55 28.232 19.741 92.129-4.457 25.027s-3.413-34.188-7.155-40.897c-3.742-6.711-6.323-6.968-8-.775-1.286 4.75-10.011 99.89.71 167.378 3.259 20.51 9.419 33.525 15.916 50.556l-.11 17.808s-17.806-49.161-22.065-77.032"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4950)",
    stroke: "none",
    d: "M668.954 1159.839l40.773-148.645s5.162-9.935 5.678-12.645c0 0 .967-144.58.194-149.032-.775-4.451-1.742-77.807-4.064-87.483-2.323-9.678-17.227-63.486-19.356-76.646-2.128-13.162.031-26.297.031-26.297s4.827.79 8.301 1.366c3.474.576 8.487 1.584 8.487 1.584s17.762 20.379 20.601 30.443c0 0 1.164-4.609-.711-10.58-1.786-5.695-6.508-12.63-10.792-17.921l5.719 1.376s20.751 41.577 20.493 50.352c-.257 8.774 5.678 84.128-6.968 98.322 0 0 2.323-15.999 0-19.097-2.322-3.097-6.451-8.516-8 1.033-1.548 9.548-.774 41.032 4.129 34.581 0 0-.774 36.902-.515 60.902.257 24 1.032 119.742 1.032 119.742s5.419 8.259 5.419 29.936 4.387 59.225-3.484 80.904c-7.871 21.676-10.587 22.967-10.587 22.967l-29.8 21.548-19.612-.775-11.605 7.549z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4960)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(718.004 663.962)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b00b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.444.571s9.86 14.371 9.86 18.533c0 4.161-.387 8.418-.387 8.418s-.581-8.903-2.033-11.128C8.433 14.168 0 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4988)",
    stroke: "none",
    d: "M684.07 1156.536l1.335-.438 3.29-3.291 31.742-12.193 3.481-15.85s2.133 15.281 1.164 18.468c-.967 3.188-6.967 15.725-6.967 15.725s-19.355 13.785-19.935 13.979c-.581.194-12.775.387-12.775.387z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(732.438 665.645)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d39808",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.13s-44.387-14.775-125.419-14.775v-2.838S-63.742-17.032 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(719.17 1119.704)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5d3142",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.383.889 1.816 8.125 1.816 8.125S-3.412 21.24-4.091 22.083c-.68.843-7.267 8.762-8.826 9.02-1.559.258-10.849-.129-11.494 0-.645.129-4.258-3.742-4.258-3.742s1.199-10.668 1.405-11.217c.207-.549 5.613-12.149 5.613-12.149l10.983-5.586s6.515.368 6.902.338C-3.379-1.284 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.727 1137.52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b8a0ab",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s.218-4.067 1.548-4.519c1.331-.453 8.516 2.259 8.516 2.259l4.42-3.453S15.907-.9 16.018 0c.111.9 1.789-.003 1.789-1.681 0-1.677 1.161-6.838 0-7.484-1.162-.645-4.646-.516-4.646-.516L2.318-8.003S-1.29-5.165-1.29-3.1C-1.29-1.035-2.318.777 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700.046 1132.427)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3ddde",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s9.262 2.187 12.166-.62v7.548s-1.291 3.678-5.968 3.871C1.521 10.993 0 6.506 0 6.506z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700.046 1123.322)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3ddde",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v7.228s6.327 3.29 9.682 1.161c3.355-2.129 2.774-3.836 2.774-3.836L13.7-6.22 4.327-4.412z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5040)",
    stroke: "none",
    d: "M692.113 1158.034l-3.418-5.227s-.86-9.445-.753-10.042c.108-.596 3.85-8.902 3.85-8.902l.321 1.436v8.411l2.905 5.551 6.5 1.254s8.47-5.773 9.37-5.514c.901.258 7.305-8.618 7.305-8.618s3.642-9.921 3.008-10.458c-.635-.537-1.6-3.891-1.6-3.891s2.25 1.161 2.705 1.548c.453.387 2.518 7.029 1.744 7.579-.774.549-3.613 9.453-3.613 9.453l-6.065 10.193-8.525 6.71s-6.571 2.322-7.087 2.322c-.517 0-6.647-1.805-6.647-1.805"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5060)",
    stroke: "none",
    d: "M696.854 1150.559c-2.003-.555-3.499-1.815-4.448-3.742-2.045-4.158-1.278-11.144 2.002-18.231 3.62-7.826 10.835-11.667 17.076-11.667 1.326 0 2.607.173 3.801.518 2.491.72 4.228 2.124 5.16 4.171 1.707 3.743.558 9.506-3.414 17.126-4.045 7.761-12.757 12.073-18.155 12.073-.744 0-1.425-.082-2.022-.248m-.96-21.355c-3.051 6.592-3.843 13.251-2.016 16.962.742 1.509 1.897 2.49 3.432 2.917.429.119.94.178 1.516.178 4.459 0 12.784-3.602 16.75-11.209 3.751-7.197 4.888-12.525 3.379-15.834-.735-1.613-2.128-2.727-4.144-3.309a12.087 12.087 0 00-3.362-.459c-5.648.001-12.222 3.548-15.555 10.754"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5080)",
    stroke: "none",
    d: "M694.278 1160.644c-2.468-.723-4.312-2.36-5.48-4.865-2.52-5.404-1.575-14.484 2.465-23.696 4.462-10.171 13.352-15.164 21.041-15.164 1.634 0 3.212.225 4.684.674 3.069.936 5.209 2.76 6.358 5.421 2.103 4.865.687 12.354-4.208 22.259-4.984 10.088-15.718 15.693-22.369 15.693-.916 0-1.755-.107-2.491-.322m-1.183-27.757c-3.759 8.569-4.734 17.223-2.485 22.047.916 1.961 2.338 3.236 4.231 3.791.528.155 1.157.232 1.866.232 5.496 0 15.753-4.684 20.638-14.569 4.622-9.356 6.024-16.279 4.165-20.581-.906-2.097-2.624-3.545-5.106-4.302a14.232 14.232 0 00-4.143-.595c-6.958 0-15.058 4.612-19.166 13.977"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5108)",
    stroke: "none",
    d: "M607.018 1190.291l20.709-1.097 35.42-11.032 3.487-4.645 5.029-12.903 13.742-4.516s1.162 11.419 5.807 12.58c4.645 1.161 22.645 1.742 33.677-27.29l11.032-19.354s-7.161 29.354-14.903 38.58c-7.742 9.225-34.259 32.064-76.646 38.645 0 0-25.354 2.71-37.354 2.71z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5136)",
    stroke: "none",
    d: "M607.018 1045.968s22.452.582 52.903-7.935c30.452-8.516 49.806-26.839 49.806-26.839s-.891 31.239-12.903 76.703c-3.871 14.652-31.245 84.282-31.245 84.282l-8.626 7.822-49.935 8.419z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5156)",
    stroke: "none",
    d: "M655.018 1122.71s2.613-21.871 3.193-25.452c.581-3.58 3.194-3.967 3.194-3.967s9.097-2.419 13.935-3.097c4.84-.677 2.419 3.58 2.419 3.58s-7.257 25.84-8.322 26.613c-1.065.775-12.774 4.259-12.774 4.259a2.545 2.545 0 01-.736.126c-1.497 0-.909-2.062-.909-2.062"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(662.244 1122.033)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccb6be",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h1.617s2.125-9.162 3.674-11.613c1.548-2.451 6.967-9.806 7.612-12.387.645-2.581.775-4.903.775-5.291C13.678-29.678 0-27.484 0-27.484s-2.322.387-2.322 2.065v6.709S0-15.742.129-11.226 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(646.502 1153.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#be8708",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.572-14.831L5.083-29.67l2.499-14.842c.832-4.941 1.631-9.911 2.559-14.811l.003-.017.006-.067c.075-.761.619-1.588 1.316-2.107.722-.53 1.607-.865 2.531-1.052l5.865-.92 11.752-1.86.012-.002.025-.005c1.001-.198 2.157.068 2.446.992.327.93.085 2.094-.218 3.198-.631 2.256-1.334 4.52-2.025 6.775l-4.165 13.547-4.188 13.543-4.147 13.556 4.531-13.433L28.32-40.64c1.462-4.494 2.94-8.983 4.353-13.494.704-2.259 1.415-4.505 2.069-6.795.299-1.141.653-2.416.207-3.758-.223-.671-.831-1.247-1.5-1.462-.676-.231-1.322-.231-2.004-.111l.037-.007-11.788 1.803c-1.969.303-3.918.598-5.899.942-1.015.212-2.032.589-2.912 1.242-.858.683-1.561 1.61-1.679 2.848l.01-.083c-.914 4.963-1.681 9.906-2.49 14.863-.809 4.952-1.557 9.913-2.319 14.872l-2.25 14.883z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5192)",
    stroke: "none",
    d: "M631.985 1050.807c-.193-3.677-14.903-2.322-24.774-2.322l-.193-2.517s22.258-.967 24.58-1.354c2.323-.387 2.71 1.354 2.71 2.516 0 1.161-2.516 82.452-6.967 105.677 0 0 5.087-93.593 4.644-102"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5202)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(665.58 1172.18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc9b08",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l6.084-11.565S1.052 5.531-2.045 8.112c-3.097 2.58-20.419 11.516-56.516 11.516v-3.387l15.581-1.065 23.806-3.096 10.549-4.258 7.451-5.42z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5224)",
    stroke: "none",
    d: "M607.018 1185.517c10.323 0 25.032-.774 36.387-2.839 11.355-2.064 22.451-10.71 22.451-10.71s0 9.678-20.386 14.323c-16.418 3.74-38.452 4-38.452 4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5252)",
    stroke: "none",
    d: "M731.663 873.646s1.263-1.937 2.323-4c1.059-2.063.257-11.355 0-12.645-.258-1.291-1.807-2.71-1.807-2.71v-6.451c1.032.515 2.064 1.419 2.839 3.225.774 1.806 1.42 12.065 1.42 12.065s.128 7.161-.646 8.839c-.774 1.677-4.129 6.451-4.129 6.451z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(715.599 1047.182)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#452510",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v22.109s1.355 2.129 3.29 3.484c1.936 1.355 12.484 8.71 12.484 8.71s4.065 1.064 4.162-1.646c.096-2.709 2.419-33.58 2.419-34.064 0-.484.774-20.226-2.419-28.452 0 0 .064 32.464-1.259 37.355C17.355 12.387 2.903 0 2.903 0S.677-.722 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5288)",
    stroke: "none",
    d: "M716.566 1068.484c-.386-1.032-.386-5.29-.386-5.29h.967s14.774 11.291 15.807 11.42c1.032.128 1.935-.839 1.935-.839s.515 6.194-.646 6.839a.258.258 0 01-.124.025c-1.886 0-17.176-11.15-17.553-12.155"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5312)",
    stroke: "none",
    d: "M716.566 1061.066c-.386-1.033-.386-5.291-.386-5.291h.967s14.774 11.29 15.807 11.419c1.032.129 1.935-.839 1.935-.839s.515 6.194-.646 6.839a.257.257 0 01-.124.026c-1.886.001-17.176-11.15-17.553-12.154"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5336)",
    stroke: "none",
    d: "M716.566 1053.44c-.386-1.032-.386-5.29-.386-5.29h.967s14.774 11.29 15.807 11.419c1.032.129 1.935-.839 1.935-.839s.515 6.194-.646 6.839a.246.246 0 01-.124.026c-1.886.001-17.176-11.15-17.553-12.155"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5360)",
    stroke: "none",
    d: "M726.438 957.807c.193-.29 25.161-9.58 26.128-9.774.968-.194 2.033 1.065 2.033 1.065l-.968 1.741-27.856 8.593s.468-1.334.663-1.625"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5388)",
    stroke: "none",
    d: "M726.147 968.646c-2.613-.774-5.129-7.258-5.129-7.645 0 0 2.71-.871 4.757-1.569 2.047-.699 20.598-7.431 22.147-8.206 1.548-.774 6.29-2.709 6.677-2.128.387.58 1.257 3.386.483 6.387-.773 3-10.741 10.838-15.484 13.161-1.86.911-3.929 1.226-5.915 1.226-3.074 0-5.949-.756-7.536-1.226"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5398)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(476.669 814.033)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#55353c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s2.161 14 3.871 16.516c1.71 2.516 3.065 2.903 3.065 2.903l5.516-12.967-3.581-22.355S2.871-21.621.839-22c-2.032-.38-4.355 4.742-4.548 5.032-.194.29 1.161 10.742 1.161 10.742z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.671 822.99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#957b7e",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-3.486-23.408-6.099-25.924c-2.613-2.516-3.678 1.741-3.678 1.741s.775-10.257.968-10.645c.194-.387 9.581-3.677 9.581-2.226 0 1.452 1.161 19.839 1.161 19.839L1.159-.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5434)",
    stroke: "none",
    d: "M509.112 1028.803c-.511-1.864-19.259-23.028-19.259-23.028s-1.7-47.097-1.7-49.42c0-2.322-1.548-50.709-1.548-53.419 0-2.709 3.248-50.71 3.248-50.71l4.811-46.432 3.167-51.966 36.124-62.111 73.036-1.162v341.284l-8.238 5.994s-89.13-7.166-89.641-9.03"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.992 1035.452)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483a2c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v11.73l-77.052-.246-19.675-28.258-13.402-17.613 2.32-5.032 9.082 3.871s14.837 11.613 16.331 12.581C-80.903-22-23.032-2.064-22.452-2.064-21.871-2.064 0 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5470)",
    stroke: "none",
    d: "M524.54 807.71c-2.891-1.157 2.451-30.838 1.164-32.94-1.288-2.101 10.88-50.475 10.062-54.415-.819-3.938 4.645-21.677 4.645-21.677l30.062-2.839h36.518l.946 10.065c-71.226 0-64.945 12.387-64.945 12.387s-2.839 37.161-3.871 48.742c-1.033 11.58 4.129 15.258 8.774 18.355 4.645 3.097 61.058 2.064 61.058 2.064l-1.962 9.549s-26.064 13.935-28.903 14.709c-.271.074-.949.108-1.959.108-9.588 0-48.974-3.061-51.589-4.108"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5494)",
    stroke: "none",
    d: "M499.183 996.931s5.433-20.671 3.883-22.31c-1.55-1.639 13.674-49.201 15.474-50.137 1.799-.935 58.774 8.517 58.774 8.517l29.462 10.838 2.177 6.968h-13.574s-21.114 0-36.751-3.354c-15.636-3.356-30.088-4.904-30.088-4.904s-8.129-1.806-10 3.355c-1.871 5.161-10.391 43.613-10.391 43.613s-1.535 10.581 5.815 14.709c7.35 4.129 33.157 25.807 93.027 25.807l1.285 5.419s-1.113.046-3.132.046c-14.157 0-72.932-2.265-105.961-38.567"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5504)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(607.938 701.904)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a99597",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-63.174-.687-69.996 6.495c-6.821 7.182-2.821-7.243-2.821-7.243s5.201-30.026 5.347-30.406c.146-.381 66.524 1.863 66.524 1.863z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(541.572 675.194)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7b6163",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h65.419v-20l-53.226 2.517s-8.516 2.129-9.484 3.773C1.742-12.064-2.354-1.161-2.354-1.161z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5536)",
    stroke: "none",
    d: "M510.265 950.549S524.54 808.871 524.54 807.71c0-1.161 4.516-125.806 4.516-125.806l6.452-28.129 32.258-8.71 39.225 2.775v9.805c-61.677 0-63.225 10.323-65.419 17.549-2.194 7.226-10.194 114.581-10.194 118.452 0 3.871 8.258 3.355 8.258 3.355h68.802l.515 146.838c-42.58 0-86.865-8.773-88.671-8.516-1.806.258-10.017 27.987-10.017 27.987z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5560)",
    stroke: "none",
    d: "M492.135 974.55l7.437-16.065 6.581-2.323s13.742-52.451 10.258-116.709c0 0-14.117 3.856-17.897 9.089v-13.347s3.768-5.227 16.542-8.324c0 0-.387-47.612-1.548-52.838-1.161-5.226-2.599-15.483-4.396-5.806-1.798 9.677-10.314 42.776-10.598 64.645-.285 21.868-6.379-58.065-6.379-58.065l6.082-34.452 18.759-3.097s3.693 27.808 3.693 29.775c0 1.968 1.936 91.063 1.936 94.322 0 3.259-5.335 76.722-5.335 76.722l-18.743 48.22z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5570)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.217 661.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#955808",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-15.484 20.903-15.774 21.484c-.29.58-2.807 10.645-3 11.323-.194.677 6.484.581 8.129 0C-9 32.227 6.818 2.75 7.355 1.259c.537-1.492 1.079-3 .54-2.807C7.355-1.354 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.828 662.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2b50b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-15.61 19.987-16.771 25.117c-1.162 5.129-2.613 3.774-2.613 3.677 0-.097 1.965-11.175 1.965-11.175S-9.548 4.257-8.902 2.783c.647-1.472 4.677-3.989 4.677-3.989z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(481.572 667.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#370f35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.064 6.258-1.291-.904v-57.032l1.677 2.995z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5606)",
    stroke: "none",
    d: "M479.507 619.195s57.807-15.484 127.484-15.484v47.741s-72.774-1.548-125.419 14.193c0 0-1.548-45.676-2.065-46.45"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5630)",
    stroke: "none",
    d: "M498.494 980.741c6.498-17.031 12.658-30.046 15.916-50.556 10.721-67.488 1.997-162.628.71-167.378-1.676-6.193-4.258-5.936-8 .775-3.742 6.709-7.154 40.897-7.154 40.897l-4.458-25.027 19.741-92.129 6.55-28.232 19.773-3.896s-3.484 30.967-7.741 53.031c-4.258 22.065-8.904 185.42-13.162 213.291-4.258 27.871-22.065 77.032-22.065 77.032z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5658)",
    stroke: "none",
    d: "M538.088 1165.774l-19.612.775-29.8-21.548s-2.716-1.291-10.588-22.967c-7.87-21.679-3.484-59.227-3.484-80.904s5.42-29.936 5.42-29.936.774-95.742 1.032-119.742-.516-60.902-.516-60.902c4.903 6.451 5.677-25.033 4.129-34.581-1.548-9.549-5.677-4.13-8-1.033-2.323 3.098 0 19.097 0 19.097-12.645-14.194-6.71-89.548-6.968-98.322-.257-8.775 20.494-50.352 20.494-50.352l5.718-1.376c-4.284 5.291-9.005 12.226-10.792 17.921-1.875 5.971-.71 10.58-.71 10.58 2.838-10.064 20.6-30.443 20.6-30.443s5.013-1.008 8.487-1.584c3.475-.576 8.301-1.366 8.301-1.366s2.16 13.135.031 26.297c-2.129 13.16-17.033 66.968-19.355 76.646-2.323 9.676-3.29 83.032-4.064 87.483-.774 4.452.193 149.032.193 149.032.516 2.71 5.678 12.645 5.678 12.645l40.774 148.645 4.636 13.484z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5668)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.005 663.962)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b00b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.444.571s-9.86 14.371-9.86 18.533c0 4.161.387 8.418.387 8.418s.581-8.903 2.033-11.128C-8.433 14.168 0 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5696)",
    stroke: "none",
    d: "M515.831 1172.936c-.582-.194-19.936-13.979-19.936-13.979s-6.001-12.537-6.968-15.725c-.968-3.187 1.164-18.468 1.164-18.468l3.482 15.85 31.741 12.193 3.29 3.291 1.336.438-1.336 16.787s-12.193-.193-12.773-.387"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(481.572 665.645)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d39808",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.13s44.387-14.775 125.419-14.775v-2.838S63.742-17.032 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.838 1119.704)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5d3142",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.384.889-1.816 8.125-1.816 8.125S3.412 21.24 4.091 22.083c.68.843 7.267 8.762 8.826 9.02 1.559.258 10.849-.129 11.494 0 .645.129 4.258-3.742 4.258-3.742s-1.198-10.668-1.405-11.217c-.207-.549-5.613-12.149-5.613-12.149L10.668-1.591s-6.515.368-6.902.338C3.379-1.284 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(516.282 1137.52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b8a0ab",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.218-4.067-1.548-4.519c-1.33-.453-8.516 2.259-8.516 2.259l-4.42-3.453S-15.907-.9-16.018 0c-.111.9-1.788-.003-1.788-1.681 0-1.677-1.162-6.838 0-7.484 1.161-.645 4.645-.516 4.645-.516l10.843 1.678S1.291-5.165 1.291-3.1C1.291-1.035 2.318.777 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(513.964 1132.427)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3ddde",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-9.263 2.187-12.166-.62v7.548s1.291 3.678 5.968 3.871C-1.521 10.993 0 6.506 0 6.506z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(513.964 1123.322)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3ddde",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v7.228s-6.327 3.29-9.682 1.161c-3.355-2.129-2.774-3.836-2.774-3.836L-13.7-6.22l9.373 1.808z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5748)",
    stroke: "none",
    d: "M508.163 1157.517l-8.526-6.71-6.064-10.193s-2.84-8.904-3.614-9.453c-.774-.55 1.291-7.192 1.744-7.579.455-.387 2.705-1.548 2.705-1.548s-.965 3.354-1.599 3.891c-.635.537 3.008 10.458 3.008 10.458s6.403 8.876 7.304 8.618c.9-.259 9.37 5.514 9.37 5.514l6.5-1.254 2.905-5.551v-8.411l.321-1.436s3.742 8.306 3.85 8.902c.107.597-.753 10.042-.753 10.042l-3.418 5.227s-6.13 1.805-6.647 1.805c-.516 0-7.086-2.322-7.086-2.322"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5768)",
    stroke: "none",
    d: "M496.979 1138.734c-3.972-7.62-5.122-13.383-3.415-17.126.933-2.047 2.669-3.451 5.16-4.171a13.704 13.704 0 013.802-.518c6.24 0 13.455 3.841 17.076 11.667 3.279 7.087 4.046 14.073 2.001 18.231-.949 1.927-2.444 3.187-4.448 3.742-.597.166-1.277.248-2.022.248-5.397 0-14.109-4.312-18.154-12.073m2.219-19.825c-2.015.582-3.409 1.696-4.144 3.309-1.508 3.309-.372 8.637 3.38 15.834 3.966 7.607 12.29 11.209 16.749 11.209.576 0 1.087-.059 1.516-.178 1.536-.427 2.691-1.408 3.433-2.917 1.826-3.711 1.034-10.37-2.016-16.962-3.334-7.206-9.908-10.754-15.555-10.754-1.173 0-2.307.154-3.363.459"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5788)",
    stroke: "none",
    d: "M494.871 1145.273c-4.895-9.905-6.311-17.394-4.208-22.259 1.149-2.661 3.289-4.485 6.358-5.421a16.056 16.056 0 014.684-.674c7.69 0 16.579 4.993 21.041 15.164 4.04 9.212 4.985 18.292 2.465 23.696-1.168 2.505-3.012 4.142-5.48 4.865-.736.215-1.574.322-2.491.322-6.651-.001-17.385-5.606-22.369-15.693m2.734-25.768c-2.482.757-4.2 2.205-5.106 4.302-1.859 4.302-.457 11.225 4.165 20.581 4.886 9.885 15.143 14.569 20.638 14.569.709 0 1.338-.077 1.867-.232 1.892-.555 3.315-1.83 4.23-3.791 2.249-4.824 1.274-13.478-2.485-22.047-4.108-9.366-12.207-13.978-19.166-13.977-1.445 0-2.842.199-4.143.595"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5816)",
    stroke: "none",
    d: "M569.637 1199.259c-42.387-6.581-68.904-29.42-76.645-38.645-7.743-9.226-14.904-38.58-14.904-38.58l11.032 19.354c11.032 29.032 29.032 28.451 33.677 27.29 4.646-1.161 5.807-12.58 5.807-12.58l13.742 4.516 5.029 12.903 3.487 4.645 35.42 11.032 20.709 1.097v11.678c-11.999 0-37.354-2.71-37.354-2.71"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5844)",
    stroke: "none",
    d: "M557.056 1180.001l-8.626-7.822s-27.374-69.63-31.245-84.282c-12.011-45.464-12.903-76.703-12.903-76.703s19.355 18.323 49.807 26.839c30.451 8.517 52.902 7.935 52.902 7.935v142.452z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5864)",
    stroke: "none",
    d: "M557.347 1124.646s-11.71-3.484-12.775-4.259c-1.064-.773-8.322-26.613-8.322-26.613s-2.419-4.257 2.419-3.58c4.839.678 13.935 3.097 13.935 3.097s2.613.387 3.194 3.967c.58 3.581 3.194 25.452 3.194 25.452s.587 2.062-.91 2.062c-.204 0-.447-.038-.735-.126"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5874)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.766 1122.033)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccb6be",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-1.617S-3.742-9.162-5.29-11.613c-1.548-2.451-6.968-9.806-7.613-12.387-.645-2.581-.774-4.903-.774-5.291 0-.387 13.677 1.807 13.677 1.807s2.323.387 2.323 2.065v6.709S0-15.742-.129-11.226 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567.508 1153.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#be8708",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.155-14.897-2.251-14.883c-.761-4.959-1.51-9.92-2.318-14.872-.809-4.957-1.577-9.9-2.49-14.863l.009.083c-.117-1.238-.82-2.165-1.679-2.848-.879-.653-1.897-1.03-2.911-1.242-1.981-.344-3.93-.639-5.9-.942l-11.787-1.803.036.007c-.681-.12-1.328-.12-2.004.111-.668.215-1.276.791-1.499 1.462-.447 1.342-.092 2.617.207 3.758.654 2.29 1.365 4.536 2.068 6.795 1.413 4.511 2.892 9 4.354 13.494l4.435 13.465 4.53 13.433-4.146-13.556-4.188-13.543-4.166-13.547c-.69-2.255-1.393-4.519-2.024-6.775-.303-1.104-.545-2.268-.218-3.198.289-.924 1.444-1.19 2.445-.992l.025.005.013.002 11.752 1.86 5.864.92c.924.187 1.809.522 2.532 1.052.697.519 1.241 1.346 1.315 2.107l.007.067.003.017c.928 4.9 1.727 9.87 2.559 14.811l2.498 14.842 2.511 14.839z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5900)",
    stroke: "none",
    d: "M579.701 1047.13c0-1.162.388-2.903 2.71-2.516 2.323.387 24.58 1.354 24.58 1.354l-.193 2.517c-9.871 0-24.581-1.355-24.774 2.322-.442 8.407 4.645 102 4.645 102-4.452-23.225-6.968-104.516-6.968-105.677"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5910)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.43 1172.18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc9b08",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-6.084-11.565S-1.052 5.531 2.045 8.112c3.097 2.58 20.419 11.516 56.516 11.516v-3.387L42.98 15.176 19.174 12.08 8.625 7.822l-7.451-5.42z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5932)",
    stroke: "none",
    d: "M568.54 1186.291c-20.387-4.645-20.387-14.323-20.387-14.323s11.096 8.646 22.451 10.71c11.356 2.065 26.064 2.839 36.387 2.839v4.774s-22.034-.26-38.451-4"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5960)",
    stroke: "none",
    d: "M478.218 871.969c-.774-1.678-.646-8.839-.646-8.839s.646-10.259 1.42-12.065c.774-1.806 1.806-2.71 2.838-3.225v6.451s-1.549 1.419-1.806 2.71c-.258 1.29-1.06 10.582 0 12.645 1.059 2.063 2.322 4 2.322 4v4.774s-3.354-4.774-4.128-6.451"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath5970)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(498.411 1047.182)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#452510",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v22.109s-1.355 2.129-3.291 3.484c-1.935 1.355-12.483 8.71-12.483 8.71s-4.065 1.064-4.162-1.646c-.097-2.709-2.419-33.58-2.419-34.064 0-.484-.774-20.226 2.419-28.452 0 0-.064 32.464 1.258 37.355C-17.355 12.387-2.903 0-2.903 0S-.678-.722 0 0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient5996)",
    stroke: "none",
    d: "M479.766 1080.614c-1.161-.645-.646-6.839-.646-6.839s.904.967 1.936.839c1.033-.129 15.806-11.42 15.806-11.42h.969s0 4.258-.387 5.29c-.377 1.005-15.667 12.156-17.554 12.155a.287.287 0 01-.124-.025"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient6020)",
    stroke: "none",
    d: "M479.766 1073.194c-1.161-.645-.646-6.839-.646-6.839s.904.968 1.936.839c1.033-.129 15.806-11.419 15.806-11.419h.969s0 4.258-.387 5.291c-.377 1.004-15.667 12.155-17.554 12.154a.272.272 0 01-.124-.026"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient6044)",
    stroke: "none",
    d: "M479.766 1065.569c-1.161-.645-.646-6.839-.646-6.839s.904.968 1.936.839c1.033-.129 15.806-11.419 15.806-11.419h.969s0 4.258-.387 5.29c-.377 1.005-15.667 12.156-17.554 12.155a.272.272 0 01-.124-.026"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient6068)",
    stroke: "none",
    d: "M460.379 950.839l-.968-1.741s1.065-1.259 2.032-1.065c.968.194 25.936 9.484 26.129 9.774.194.291.663 1.625.663 1.625z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient6096)",
    stroke: "none",
    d: "M474.411 968.646c-4.742-2.323-14.71-10.161-15.484-13.161-.774-3.001.097-5.807.484-6.387.386-.581 5.129 1.354 6.677 2.128 1.548.775 20.099 7.507 22.147 8.206 2.046.698 4.757 1.569 4.757 1.569 0 .387-2.516 6.871-5.13 7.645-1.587.47-4.462 1.226-7.536 1.226-1.986 0-4.055-.315-5.915-1.226"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient6120)",
    stroke: "none",
    d: "M634.262 806.7c1.141 29.027 3.949 114.344-1.642 132.718 0 0 2.096-100.002 1.642-132.718m-.405-9.699c.206 1.25.335 4.684.405 9.699-.239-6.086-.405-9.699-.405-9.699"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient6144)",
    stroke: "none",
    d: "M582.243 799.839s2.323 123.355 0 137.549c0 0-3.612-109.678 0-137.549"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6154)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6162)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.47 749.857)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.004.005-13.385-30.85-13.967-36.985-.583-6.136-3.324-20.118-2.807-22.318.516-2.199 14.709 12.479 15.742 19.85C0-32.082 1.806-2.757 0 0"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6178)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.34 1112.355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l6.727 7.476S2.888-38.306 4.925-41.548c2.037-3.243 3.699-1.29 3.699-1.29S.703-79.778 0-87.485c0 0-5.508 22.969-5.077 29.163C-4.645-52.129 0 0 0 0"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6194)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(518.54 1083.71)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-9.233-45.877s7.13 3.117 10.485 1.232c3.355-1.885 6.812-10.839 6.812-10.839s52.811 16.202 54.871 16.355c2.06.153 2.83 3.456 6.188 3.568 3.358.113 41.031-.885 42.323-.967 1.291-.083 2.549-2.601 2.549-2.601s52.432-9.349 74.36-32.207c0 0 6.094-9.141 7.689-4.277 1.595 4.864-1.014 47.742 0 51.355 1.015 3.613 1.595 12.465 1.595 12.465s-2.54 38.402-7.484 43.793l-6.709 1.208s9.695-49.208 2.911-62.627c0 0 5.145-29.42 4.83-40.774 0 0-11.706 72-16.82 82.064 0 0-13.579 2.12-13.523 1.939.055-.182-1.019-.391-1.019-.391l-2.444 4.904s-16.858 1.47-17.548.258c-.69-1.213-1.554-4.12-2.971-3.608-1.416.511 1.422-.07-3.997 1.124-5.419 1.194-19.448 1.919-19.405 1.147.043-.771 2.241-51.448 2.241-51.448s-3.481.14-3.481 3.495c0 3.354-.825 49.829-.825 49.829s-21.369 2.816-31.433-.539l-10.065-3.355-4.015 10.846-.665-13.425-.782-46.851s-.989-.138-1.505 0c-.516.14.413 49.177.413 49.177s-13.848-5.488-19.51-5.987c-5.662-.499-20.027-4.799-20.027-4.799z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(518.54 1083.71)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0l-9.233-45.877s7.13 3.117 10.485 1.232c3.355-1.885 6.812-10.839 6.812-10.839s52.811 16.202 54.871 16.355c2.06.153 2.83 3.456 6.188 3.568 3.358.113 41.031-.885 42.323-.967 1.291-.083 2.549-2.601 2.549-2.601s52.432-9.349 74.36-32.207c0 0 6.094-9.141 7.689-4.277 1.595 4.864-1.014 47.742 0 51.355 1.015 3.613 1.595 12.465 1.595 12.465s-2.54 38.402-7.484 43.793l-6.709 1.208s9.695-49.208 2.911-62.627c0 0 5.145-29.42 4.83-40.774 0 0-11.706 72-16.82 82.064 0 0-13.579 2.12-13.523 1.939.055-.182-1.019-.391-1.019-.391l-2.444 4.904s-16.858 1.47-17.548.258c-.69-1.213-1.554-4.12-2.971-3.608-1.416.511 1.422-.07-3.997 1.124-5.419 1.194-19.448 1.919-19.405 1.147.043-.771 2.241-51.448 2.241-51.448s-3.481.14-3.481 3.495c0 3.354-.825 49.829-.825 49.829s-21.369 2.816-31.433-.539l-10.065-3.355-4.015 10.846-.665-13.425-.782-46.851s-.989-.138-1.505 0c-.516.14.413 49.177.413 49.177s-13.848-5.488-19.51-5.987c-5.662-.499-20.027-4.799-20.027-4.799z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6214)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.308 921.646)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.774 0 20.129 4.645 24.774 6.968 4.645 2.322 5.865 6.459 5.865 6.459s-7.413-3.879 3.168-1.814c10.58 2.064 35.096 9.548 42.064 8 6.968-1.549 1.291-1.549 8-2.839 6.71-1.29 45.961-4.941 50.065-9.29 4.103-4.35 0-28.129 0-28.129s4.58 2.838 4.096 1.032-3.239-82.117-3.385-85.207c-.146-3.09-3.034.304-4.324 2.368-1.291 2.065-.775-4.129-4.387-5.419-3.613-1.29-36.904 0-41.549-4.129-4.645-4.129 1.291-7.121-12.129-5.367-13.419 1.754-22.322 2.27-22.322 2.27S32-71.742 31.226-71.742c-.774 0-2.58-35.097-2.58-35.097s.257 38.065-.517 48.323C27.355-48.258 8.667-18.968 7.301-14.258 5.936-9.548 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.308 921.646)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0c.774 0 20.129 4.645 24.774 6.968 4.645 2.322 5.865 6.459 5.865 6.459s-7.413-3.879 3.168-1.814c10.58 2.064 35.096 9.548 42.064 8 6.968-1.549 1.291-1.549 8-2.839 6.71-1.29 45.961-4.941 50.065-9.29 4.103-4.35 0-28.129 0-28.129s4.58 2.838 4.096 1.032-3.239-82.117-3.385-85.207c-.146-3.09-3.034.304-4.324 2.368-1.291 2.065-.775-4.129-4.387-5.419-3.613-1.29-36.904 0-41.549-4.129-4.645-4.129 1.291-7.121-12.129-5.367-13.419 1.754-22.322 2.27-22.322 2.27S32-71.742 31.226-71.742c-.774 0-2.58-35.097-2.58-35.097s.257 38.065-.517 48.323C27.355-48.258 8.667-18.968 7.301-14.258 5.936-9.548 0 0 0 0z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath6234)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.828 713.388)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.005.209 17.964-30.968 17.964-30.968L8.438 9.807s9.797-22.968 13.404-27.355c3.606-4.388 4.381-10.839 6.445-7.484 2.065 3.355 4.107 65.473 4.107 65.473s8.485-62.377 9.028-75.021c.542-12.646 4.159-19.671 1.032-19.858-3.126-.186-8.175-.951-10.327 5.012-2.151 5.964-5.904 17.168-6.679 17.426-.774.258-5.119-1.548-3.592-4.903 1.528-3.355 3.592-13.677 3.592-13.677s-6.709-6.71-14.968 2.838C2.223-38.193-1.648-25.378-1.906-18.624-2.165-11.871-2.481-.516 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.828 713.388)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0c1.005.209 17.964-30.968 17.964-30.968L8.438 9.807s9.797-22.968 13.404-27.355c3.606-4.388 4.381-10.839 6.445-7.484 2.065 3.355 4.107 65.473 4.107 65.473s8.485-62.377 9.028-75.021c.542-12.646 4.159-19.671 1.032-19.858-3.126-.186-8.175-.951-10.327 5.012-2.151 5.964-5.904 17.168-6.679 17.426-.774.258-5.119-1.548-3.592-4.903 1.528-3.355 3.592-13.677 3.592-13.677s-6.709-6.71-14.968 2.838C2.223-38.193-1.648-25.378-1.906-18.624-2.165-11.871-2.481-.516 0 0z"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacer2);
export default __webpack_public_path__ + "static/media/racer2.22522905.svg";
export { ForwardRef as ReactComponent };